export function useDimensions(
  size: {
    width: number;
    height: number;
  },
  target: {
    width?: number;
    height?: number;
  },
) {
  const ratio = size.width / size.height;
  if (target.width && target.height)
    return {
      width: Math.min(target.width, size.height * ratio),
      height: Math.min(target.height, size.width / ratio),
    };
  if (target.width)
    return {
      width: target.width,
      height: target.width / ratio,
    };
  if (target.height)
    return {
      width: target.height * ratio,
      height: target.height,
    };
  return size;
}
